import { message } from "antd";
import logo from "../../images/logo.png";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthService } from "../../services/Auth.service";

export default function LogIn({ notify }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await AuthService.Login(user);
      navigate("/dashboard");
    } catch (error) {
      showErrorMessage(error);
    }
    setLoading(false);
  };

  const handleInput = async (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showSuccessMessage = () => {
    messageApi.success({
      content: `User Account Created`,
      duration: 3,
    });
  };

  const showErrorMessage = (error) => {
    messageApi.error({
      content: error.response?.data?.message || "An error occurred",
      duration: 5,
    });
  };

  return (
    <div className="flex justify-center w-full items-center h-screen overflow-hidden font-euclid-circular-a">
      {contextHolder}
      <div className="flex items-center h-screen w-full">
        <div className="w-full hidden xl:block bg-backfrop h-full">
          &#x20;
          {/* <img src={account} alt="account" className="h-full w-full" /> */}
        </div>
        <div className="w-full flex justify-center">
          <div className="flex flex-col justify-center items-center mt-12">
            <img src={logo} alt="" className="mb-12 mt-4  max-w-full" />
            <div className="ml-auto mb-44">
              <h2 className="mb-12 text-center font-bold  text-xl">
                Welcome Back
              </h2>
              {/* <ErrorBoundary fallback={<p>⚠️Something went wrong</p>}> */}
              <form
                id="login_form"
                className="w-full flex justify-center"
                onSubmit={handleLogin}
              >
                <div className="w-72">
                  <div>
                    <input
                      type="email"
                      name="email"
                      onChange={handleInput}
                      value={user.email}
                      placeholder="Email address"
                      className="mb-4 w-72 text-black border border-gray-200 p-2"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="password"
                      name="password"
                      onChange={handleInput}
                      value={user.password}
                      placeholder="Password"
                      className="mb-4 w-72 border text-black border-gray-200 p-2"
                      required
                    />
                  </div>
                  {/* <Link to="/dashboard" > */}
                  <button
                    type="submit"
                    className="bg-sky-500 text-white px-4 py-2 rounded w-72"
                  >
                    {!loading ? "Login" : "Loading..."}
                  </button>

                  {/* </Link> */}

                  <p className="mb-6 text-xs mt-4">
                    Don't have an account yet?{" "}
                    <Link
                      to="/signup"
                      className="text-blue-600 hover:text-gray-400 transition duration-200 ease-in-out ml-1"
                    >
                      Signup
                    </Link>
                  </p>
                </div>
              </form>
              {/* </ErrorBoundary> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
